import {Children, cloneElement} from 'react';

import {ComboboxItem} from '../combo-box-item.component';
import {DefaultItem} from '../combo-box-item-default.component';
import {ComboboxGroup} from '../combo-box-group.component';

import type {ReactElement, ReactNode, JSXElementConstructor} from 'react';

import type {ComboboxItemProps} from '../combo-box-item.component';

export function mapItems<T>(
    children: ReactNode,
    callback: (child: ReactElement<ComboboxItemProps<T>>) => ReactNode,
): ReactNode {
    return Children.map(children, child => {
        if (child && typeof child === 'object' && 'type' in child) {
            const {type} = child;

            if (type === ComboboxItem || type === DefaultItem) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return callback(child as ReactElement<ComboboxItemProps<T>, string | JSXElementConstructor<any>>);
            }

            if (type === ComboboxGroup) {
                const childProps = child.props as Record<string, unknown>;

                return cloneElement(child, undefined, mapItems<T>(childProps?.children as ReactNode, callback));
            }
        }
        return child;
    });
}
